import { makeEmptyCaption } from '@pm2/content-engine';
import { AudioComponent } from '@pm2/media-component';
import { generateJsxKey } from '@utils/ast';
import { jsx } from 'react/jsx-runtime';

const medialibraryParsers = {
  medialibraryvideo: node => {
    return {
      nodeType: "medialibrary.video",
      referenceId: node.getAttribute("id")
    };
  },
  medialibraryaudio: node => {
    return {
      nodeType: "medialibrary.audio",
      referenceId: node.getAttribute("id")
    };
  }
};
const medialibraryPrinters = {
  "medialibrary.video": () => {
    return null;
  },
  "medialibrary.audio": (node, context) => {
    return /*#__PURE__*/jsx(AudioComponent, {
      src: node.referenceId,
      caption: makeEmptyCaption(),
      transcript: undefined,
      isScrambled: false
    }, generateJsxKey(context));
  }
};
const medialibraryToLatexPrinters = {
  "medialibrary.video": () => {
    return null;
  },
  "medialibrary.audio": () => {
    return null;
  }
};

export { medialibraryParsers, medialibraryPrinters, medialibraryToLatexPrinters };
//# sourceMappingURL=spec.medialibrary.js.map
